import React from 'react';
import { ArabicWord } from '../types';

interface WordCardProps {
  word: ArabicWord;
  playAudio: () => void;
  onPrevious?: () => void;
  onNext?: () => void;
  isCurrentDay?: boolean;
  disablePrevious?: boolean;
  displayDate?: string;
  hideNavigation?: boolean;
}

const WordCard: React.FC<WordCardProps> = ({
  word,
  playAudio,
  onPrevious,
  onNext,
  isCurrentDay,
  disablePrevious,
  displayDate,
  hideNavigation = false,
}) => {


  return (
    <div className="word-card">
      {!hideNavigation && (
        <div className="date-navigation">
          <button
            className="nav-button"
            onClick={onPrevious}
            disabled={disablePrevious}
          >
            &larr; Previous
          </button>
          <span className="display-date">{displayDate}</span>
          <button
            className="nav-button"
            onClick={onNext}
            disabled={isCurrentDay}
          >
            Next &rarr;
          </button>
        </div>
      )}
      <h2 className="english-word">{word.translation}</h2>
      <div className="arabic-section">
        <p className="arabic-word">{word.word}</p>
        <p className="romanization">{word.romanization}</p>
        <button className="play-button" onClick={playAudio}>
          Play Sound
        </button>
      </div>
      {word.example && (
        <div className="example">
          <p><strong>Example:</strong> {word.example}</p>
        </div>
      )}
    </div>
  );
};

export default WordCard;
